import { MedicalAppealDemographicsComponent } from './medical-appeal-demographics.component';
import { nhAddressCreator, sectionConfiguration } from '@app/helpers/models.helpers';
import { lookIn } from '@app/helpers/flipped.helpers';
import Vs from '@app/services/validators/validators.service';


const formValidation = (builder, recordData) => {

  const MedicalAppealDemographics = lookIn(recordData);
  const addressFormatP = MedicalAppealDemographics(['medAppealAddress', 'addressFormat']);
  const address = MedicalAppealDemographics(['medAppealAddress', 'address']);
  const householdMember = MedicalAppealDemographics(['houseHoldMember']);
  const filer = MedicalAppealDemographics(['filer']);
  const filingDate = MedicalAppealDemographics(['filingDate']);
  const appNum = MedicalAppealDemographics(['appNum']);
  const tccMaAddressSeq = MedicalAppealDemographics(['tccMaAddressSeq']);
  const data = builder.group({
      medAppealAddress: builder.group({
      address: builder.group(nhAddressCreator(address)),
      addressFormat: [ addressFormatP ],
      addressType: MedicalAppealDemographics(['medAppealAddress', 'addressType']),
      addressValidationCd: MedicalAppealDemographics(['medAppealAddress', 'addressValidationCd']),
    }),
    householdMember: householdMember,
    filer: filer,
    filingDate: filingDate,
    appNum: appNum,
    tccMaAddressSeq: tccMaAddressSeq,
    writtenLangCd: [MedicalAppealDemographics(['writtenLangCd']), Vs.required],
    indvLangPrefCd: [MedicalAppealDemographics(['indvLangPrefCd']), Vs.required],
    othIndvLangPrefDtls: [MedicalAppealDemographics(['othIndvLangPrefDtls']), [Vs.maxLength(30), Vs.otherLanguage]],
    mbrIntrpretorSw: MedicalAppealDemographics(['mbrIntrpretorSw']),
    mbrNeedIntrpretorSw: [MedicalAppealDemographics(['mbrNeedIntrpretorSw'])],
    hearLangPrefCd: [MedicalAppealDemographics(['hearLangPrefCd'])],
    othHearLangPrefDtls: [MedicalAppealDemographics(['othHearLangPrefDtls']), [Vs.maxLength(30), Vs.otherLanguage]],
    emailAdr: [MedicalAppealDemographics(['emailAdr']), [Vs.email]],
    indvPhnNum: [MedicalAppealDemographics(['indvPhnNum']), [Vs.required, Vs.phoneNumber]], 
    indvPhnNumExt: [MedicalAppealDemographics(['indvPhnNumExt'])], 
    indvAdtlPhnNum: [MedicalAppealDemographics(['indvAdtlPhnNum']), [Vs.phoneNumber]], 
    indvAdtlPhnNumExt: [MedicalAppealDemographics(['indvAdtlPhnNumExt'])],
    contactTimeCd: [MedicalAppealDemographics(['contactTimeCd'])],
    addressEditValidation: null,
  });
  return { data };
};

export default sectionConfiguration(MedicalAppealDemographicsComponent, formValidation, ['YESNO', 'CONTACTTIME', 'ADDRESSFORMATTYPES', 'WRITTENLANGUAGE', 'STATE', 'COUNTY', 'MILITARYPOCODES', 'STATEMILITARY', 'SPOKEHEARLANGUAGE'], [], {}, {
  hasSummary: false,
  showSubmit: false,
  showComments: false,
  showSaveAndExit: false
});